exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".recommendations[data-v-dc47d814] {\n  padding-top: 1.5em;\n  padding-bottom: 3em;\n  display: inline-block;\n}\n.recommendations .thanks-footer[data-v-dc47d814] {\n  text-align: center;\n}\n.recommendations .thanks-footer p[data-v-dc47d814],\n.recommendations .thanks-footer button[data-v-dc47d814] {\n  margin: 1.2em;\n}\n", ""]);

// exports
